// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--jZ2u5"};